const PeopleWorkspaceNav = () => null;

export default PeopleWorkspaceNav;
